module.exports = __webpack_public_path__ + "static/media/nangoku.661c01bc.png";